
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Link, LinkCollection } from '../../backend/backendapi';
import { emptyUUID } from '../../../util';
import Visible from '../../../directives/visible';
import CenterOnParent from '../../util/CenterOnParent';

@Component({
  components: { CenterOnParent },
  directives: {
    Visible,
  },
})
export default class CollectionEditModal extends Vue {
  @Prop({ required: true })
  collection!: LinkCollection;
  readonly showDescription = true;
  file: File | undefined;

  get links(): Link[] {
    this.collection.links ??= [];
    this.collection.links.sort((l, r) => l.order - r.order);
    return this.collection.links;
  }

  addLink(): void {
    const link = new Link();
    link.description = '';
    link.id = emptyUUID();
    link.linkCollectionId = this.collection.id;
    link.name = '';
    link.newTab = false;
    link.order = Math.max(-1, ...this.links.map(e => e.order)) + 1;
    link.url = '';
    this.links.push(link);
  }

  moveDown(index: number): void {
    const tmp = this.links[index].order;
    this.links[index].order = this.links[index + 1].order;
    this.links[index + 1].order = tmp;
  }

  moveUp(index: number): void {
    const tmp = this.links[index].order;
    this.links[index].order = this.links[index - 1].order;
    this.links[index - 1].order = tmp;
  }

  handleFileChange(): void {
    // https://stackoverflow.com/questions/65703814/how-to-upload-file-in-vue-js-version-3
    if (this.$refs.fileInput === undefined) {
      return;
    }
    
    let fileInputElement = this.$refs.fileInput as HTMLInputElement;
    if (fileInputElement.files) {
      this.file = fileInputElement.files[0];
    }
  }

  readFile(file: File): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      console.log(reader.result);
      if (reader.result?.toString() !== undefined) {
        this.collection.backgroundImage = reader.result?.toString();
        this.collection.backgroundImageName = file.name;
      }
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  setFile(): void {
    if (this.file) {
      this.readFile(this.file);
    }
  }

  clearFile(): void {
    if (this.$refs.fileInput === undefined) {
      return;
    }
    
    let fileInputElement = this.$refs.fileInput as HTMLInputElement;
    if (fileInputElement.files) {
      fileInputElement.value = '';
      this.file = undefined;
      this.collection.backgroundImage = '';
      this.collection.backgroundImageName = '';
    }
  }
}
